exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */\n/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */.hotel-details{text-decoration:underline;pointer-events:all}[dir] .hotel-details{cursor:pointer}.disabled-link{text-decoration:none}[dir] .disabled-link{cursor:auto}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/hotel-brand-info/hotel-brand-info.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/hotel-brand-info/hotel-brand-info.component.scss
// module chunks = 0